import styled from 'styled-components';

const PRIMARY = '#1976d2'; // white text on it: 4.6:1
const TEXT = '#1F2A33';
const MUTED = '#5F6B73'; // 5.47:1 on white
// Inside the dialog's own stacking context (MUI's z-index 1300): above everything in the dialog. MUI tooltips
// are portalled to body at 1500, so the picker hides the guide button's tooltip while the tour is open.
const Z = 1600;

// position: fixed — the MUI dialog fades in with opacity only, so no ancestor transform moves these
export const Spotlight = styled.div`
    position: fixed;
    z-index: ${Z};
    border: 2px solid ${PRIMARY};
    border-radius: 10px;
    // Dims everything around the ringed element
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.35);
    pointer-events: none;
    transition: top 0.2s, left 0.2s, width 0.2s, height 0.2s;
`;

export const Backdrop = styled.div`
    position: fixed;
    inset: 0;
    z-index: ${Z};
    background: rgba(0, 0, 0, 0.35);
    pointer-events: none;
`;

export const Bubble = styled.div`
    position: fixed;
    z-index: ${Z + 1};
    width: 320px;
    box-sizing: border-box;
    padding: 14px 16px 12px;
    border-radius: 10px;
    background: white;
    color: ${TEXT};
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.25);
    text-align: right;
    font-family: inherit;

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid ${PRIMARY};
        outline-offset: 2px;
    }
`;

export const StepCount = styled.div`
    font-size: 12px;
    color: ${MUTED};
`;

export const Title = styled.h3`
    margin: 2px 0 6px;
    font-size: 15px;
    font-weight: 500;
`;

export const Text = styled.p`
    margin: 0 0 12px;
    font-size: 13.5px;
    line-height: 1.5;
`;

export const Actions = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`;

export const Nav = styled.div`
    display: flex;
    gap: 8px;
`;

const buttonBase = `
    height: 32px;
    border-radius: 6px;
    font-size: 13px;
    font-family: inherit;
    cursor: pointer;

    &:focus-visible {
        outline: 2px solid ${PRIMARY};
        outline-offset: 2px;
    }
`;

export const PrimaryButton = styled.button`
    ${buttonBase}
    padding: 0 16px;
    border: 0;
    background: ${PRIMARY};
    color: white;
    font-weight: 500;
`;

export const SecondaryButton = styled.button`
    ${buttonBase}
    padding: 0 14px;
    border: 1px solid #c4c4c4;
    background: white;
    color: #424242;
`;

export const TextButton = styled.button`
    ${buttonBase}
    padding: 0 6px;
    border: 0;
    background: none;
    color: ${MUTED};
    text-decoration: underline;
`;

// The "guide" button: in the dialog header and beside the panel's open button
export const GuideButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 30px;
    padding: 0 10px;
    border: 1px solid #90caf9;
    border-radius: 15px;
    background: white;
    color: #1565c0;
    font-size: 13px;
    font-family: inherit;
    cursor: pointer;
    white-space: nowrap;

    svg {
        font-size: 18px;
    }

    &:focus-visible {
        outline: 2px solid ${PRIMARY};
        outline-offset: 2px;
    }
`;
